import Router from 'next/router'
import { MyIcon } from '~/components/ui/MyIcon'
import styles from './QuickBigPic.module.css'
import {
  timeWithUint,
  to1200Image,
  to400Image,
  to800Image,
  toTransparentBg,
  toHm,
} from '~/utils'
import {
  AiArtworkServiceStatus,
  AiCreateArtworkPattern,
  ExtendsProduct,
} from '~/graphqls/types'
import { AiArtWorkStatus } from '~/graphqls/types'
import { useMemo, useState } from 'react'

import Lightbox, { SlideImage } from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import ImageViewer, { ImageType } from './imageViewer'
/**  */
type SlideImageType = SlideImage & {}
function RenderLightBoxSlide({ slide }: { slide: SlideImageType }) {
  return (
    <div className="w-full h-full">
      <img
        src={slide.src}
        alt=""
        className={styles.slideImg}
        style={toTransparentBg({
          imgUrl: slide.src,
        })}
      />
    </div>
  )
}
export const QuickBigPic: React.FC<{
  product: ExtendsProduct | undefined
  data: ExtendsProduct[]
}> = ({ product: newProduct, data: newData }) => {
  const [lightboxOpen, setlightboxOpen] = useState(false)
  const [lightboxIndex, setLightboxIndex] = useState(0)

  const flattenedImageList = newData
    .filter(item => !!item.miniArtWorkUrl && !item.involveYellow)
    .map(item => {
      return [item.miniArtWorkUrl!, item.pretreatmentImage?.url]
    })
    .flat()
    .filter(url => !!url)

  const lightBoxImages: SlideImageType[] = flattenedImageList.map(item => {
    return { src: item! }
  })

  const handleFullScreen = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    let index = 0
    index = flattenedImageList.indexOf(newProduct?.miniArtWorkUrl as string)

    if (index === -1) {
      index = 0
    }

    setLightboxIndex(index)
    setlightboxOpen(true)
  }

  let imageList: ImageType[] = []
  if (newProduct?.miniArtWorkUrl) {
    imageList.push({
      url: newProduct.miniArtWorkUrl,
      width: newProduct.length,
      height: newProduct.width,
    })
  }
  // console.log(product)
  if (newProduct?.pretreatmentImage?.url) {
    imageList.push({
      url: newProduct.pretreatmentImage.url,
    })
  }

  return (
    <>
      {!newProduct && (
        <div className="h-[662px] w-full bg-neutral-200 rounded-lg"></div>
      )}
      {/* 生成成功，且不涉嫌违规 */}
      {!!newProduct?.miniArtWorkUrl && !newProduct?.involveYellow && (
        <div
          className="w-full rounded-lg overflow-hidden relative cursor-pointer"
          style={{
            background: `url(${
              newProduct?.miniArtWorkUrl
                ? to400Image(newProduct?.miniArtWorkUrl)
                : ''
            }) no-repeat center center / 100% 100%`,
          }}
          onClick={() => {
            Router.push(`/ai/${newProduct.id}`)
          }}
        >
          <div className="w-full h-[662px] bg-neutral-200">
            <ImageViewer previewImages={imageList} key={newProduct.id} />
          </div>

          <div
            className="w-8 h-8 flex items-center justify-center absolute
      top-2 right-2 bg-neutral-50/50 rounded-lg cursor-pointer z-10"
            style={{
              background:
                'linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.5) 100%)',
            }}
            onClick={handleFullScreen}
          >
            <MyIcon
              icon="fullscreen"
              className="text-neutral-600 text-[24px] icon"
            />
          </div>
        </div>
      )}
      {/* 生成成功，但涉嫌违规 */}
      {!!newProduct?.miniArtWorkUrl && !!newProduct?.involveYellow && (
        <div className="h-[662px] flex flex-col items-center justify-center bg-neutral-200 rounded-lg">
          <div className="w-6 h-6">
            <MyIcon icon="warning" className="text-neutral-500 text-[24px]" />
          </div>

          <div className="text-neutral-400 text-xs mt-2 text-center">
            图片涉嫌违规
          </div>
        </div>
      )}
      {/* 生成失败 */}
      {newProduct?.status === AiArtWorkStatus.FAIL && (
        <div className="h-[662px] flex flex-col items-center justify-center bg-neutral-200 rounded-lg">
          <div className="w-6 h-6">
            <MyIcon icon="file-error text-[24px] text-neutral-500" />
          </div>
          <div className="text-neutral-400 text-xs mt-2 text-center">
            {!!newProduct.failMessage?.failMessage
              ? newProduct.failMessage.failMessage!
              : '生成失败'}
          </div>
        </div>
      )}
      {/* 排队中 */}
      {[AiArtWorkStatus.TIDAL].includes(
        newProduct?.status as AiArtWorkStatus
      ) && (
        <div
          className="h-[662px] flex flex-col items-center justify-center bg-neutral-200 rounded-lg cursor-pointer"
          onClick={() => {
            Router.push(`/ai/${newProduct?.id}`)
          }}
        >
          <div className="w-6 h-6">
            <MyIcon icon="clock" className="text-neutral-500 text-[24px]" />
          </div>
          <div className="text-neutral-400 text-xs mt-2 text-center">
            排队中
          </div>
        </div>
      )}
      {/* 生成中 */}
      {[
        AiArtWorkStatus.UNGENERATE,
        AiArtWorkStatus.GENERATEING,
        AiArtWorkStatus.QUEUEING,
      ].includes(newProduct?.status as AiArtWorkStatus) && (
        <div
          className="h-[662px] w-full bg-neutral-200 rounded-lg cursor-pointer"
          onClick={() => {
            Router.push(`/ai/${newProduct?.id}`)
          }}
        >
          <img
            className="w-full h-[662px]"
            src="/images/ai/loading.png"
            alt=""
          />
        </div>
      )}
      <Lightbox
        open={lightboxOpen}
        close={() => setlightboxOpen(false)}
        index={lightboxIndex}
        slides={lightBoxImages.slice()}
        render={{
          // 自定义slide，支持透明图样式
          slide: slide => {
            return <RenderLightBoxSlide slide={slide as SlideImageType} />
          },
        }}
        carousel={{
          finite: false,
          preload: 2,
          imageFit: 'contain',
        }}
        animation={{ fade: 250, swipe: 500 }}
      />
    </>
  )
}
